import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AnyObject, InferType, ObjectSchema } from "yup";

import { updateSchool as updateSchoolAPI } from "~utils";

import { CombinedSchoolUpdateSchema } from "./SchoolProfileFormUtils";

export const useUpdateSchool = ({
  formState,

  validationSchema,
  schoolId,
}: {
  formState: CombinedSchoolUpdateSchema;

  validationSchema: ObjectSchema<AnyObject>;
  schoolId: string;
}) => {
  type SchoolUpdateAPISchema = InferType<typeof validationSchema>;
  const queryClient = useQueryClient();

  const [errors, setErrors] = useState<string[]>([]);

  const { mutate: submitGiveFeedback } = useMutation({
    mutationFn: (submissionData: SchoolUpdateAPISchema) => {
      return updateSchoolAPI(schoolId, submissionData);
    },
    onSuccess: () => {
      queryClient.invalidateQueries();
      setErrors([]);
    },
    onError: (data) => {
      setErrors([data.message]);
    },
  });

  const updateSchool = () =>
    validationSchema
      .validate(formState, { abortEarly: false })
      .then(() => {
        submitGiveFeedback(formState);
      })
      .catch(({ errors }) => {
        setErrors(errors);
        throw errors;
      });

  return { updateSchool, errors };
};
